import React, { useState, useEffect, useMemo } from 'react';
import { Container, Form, Row } from "react-bootstrap";
import { BfButtonBlue } from '../../../Styling/styledForm/styledBlueForm'
import { ButtonContainer, SubText, BfRowFormTransition, FlexContainer, RightColumn, StyledTable, THead, TBody, Th, Td, SectionContainer, SectionContainerTwo, TitleSection, RegnskapTitle, ExtraValue, SectionTable, TableBody, TableRow, LabelCell, ValueCell, GroupSubtitleRow, GroupSubtitleCell, TotalLabelCell, TotalValueCell, SectionContainerThree, KredittvurderingRowForm, Heading, HeaderBar, TitleBlock, Logo, Divider, Controls, RadioRow, FieldRow, InputWrap, CTAButton } from '../../../Styling/styledKredittvurdering/styledKvComponents'
import { BfColInput } from '../../../Styling/FormComponents/FormInput'
import { ConfirmActionModal } from '../modals/ConfirmActionModal';
import { OverlaySpinner } from '../../../components/spinner/OverlaySpinner';
import useDebitorForm from '../../caseNew/debitorForm/useDebitorForm';
import { useAuth } from '../../../hooks/useAuth';
import { useSelector } from 'react-redux'
import { næringConfigV4, privatConfigV4 } from '../ratingConfigs/ratingConfigs';
import RollerTable from './tables/RollerTable';
import FriverdierTable from './tables/FriverdierTable';
import EiendomTable from './tables/EiendomTable';
import AksjerTable from './tables/AksjerTable';
import AnmerkningerTable from './tables/AnmerkningerTable';
import UtleggstrekkTable from './tables/UtleggstrekkTable';
import IntetTilUtleggTable from './tables/IntetTilUtleggTable';
import AksjonaererTable from './tables/AksjonaererTable';
import KjoeretoeyTable from './tables/KjoeretoeyTable';
import PantTable from './tables/PantTable';
import TvangEiendomTable from './tables/TvangEiendomTable';
import MerknaderEiendomTable from './tables/MerknaderEiendomTable';
import næringPdfV4 from '../pdfs/næringPdfV4';
import privatPdfV4 from '../pdfs/privatPDFV4';
import IframeModal from '../../../components/iframeModal/IframeModal';
import { RatingToolTip } from './RatingToolTip';
import { getScoreColor } from '../ratingConfigs/ratingColor';
import LogoImage from '../image/bislab.png';


const KredittvurderingRatingForm = (props) => {

    const {
        handleChange, formState, errorMessages
    } = useDebitorForm(props.state, props.dispatch, props.showToasts, props.localeMessages)

    const localeMessages = props.localeMessages
    const kredittvurderingState = props.kredittvurderingState;
    const companyRatingData = kredittvurderingState.companyRatingData[0];
    const personRatingData = kredittvurderingState.personRatingData[0];
    
    const [showConfirmActionModal, setShowConfirmActionModal] = useState(false);
    const [selectedNumber, setSelectedNumber] = useState("");
    const [formType, setFormType] = useState('');
    const auth = useAuth();
    const crState = useSelector(state => state.sakslisteHeader)
    const headerState = useSelector(state => state.sakslisteHeader)

    const [showPrivatContent, setShowPrivatContent] = useState(false);
    const [showNæringContent, setShowNæringContent] = useState(false);

    const [pdfUrl, setPdfUrl] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)

    // For å vise preview av pdf til nedlasting
    useEffect(() => {
      return () => {
        if (pdfUrl) URL.revokeObjectURL(pdfUrl)
      }
    }, [pdfUrl])

    // 2x useEffect som forhindrer at flere formfields er synlig når flere søk blir gjort på både næring og privat
    useEffect(() => {
        if (personRatingData && personRatingData !== undefined) {
            formState.debtorType = 'Privat';
            setShowPrivatContent(true);
            setShowNæringContent(false);
            setFormType('Privat');
        } else if (companyRatingData && companyRatingData !== undefined) {
            formState.debtorType = 'Næring';
            setShowNæringContent(true);
            setShowPrivatContent(false);
            setFormType('Næring');
        } else {
            formState.debtorType = '';
            setShowNæringContent(false);
            setShowPrivatContent(false);
            setFormType('');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyRatingData, personRatingData]);

    useEffect(() => {
        if (formState.debtorType === 'Privat') {
            setFormType('Privat');
        } else if (formState.debtorType === 'Næring') {
            setFormType('Næring');
        } else {
            setFormType('');
        }

    }, [formType, formState]);

    const getFormField = (colspan, fieldname, inputType = 'cleaveOrgPersonNr', selectOptions = '', disabled = false, maxLength = 11) => {
      return (
        <BfColInput
          colspan={colspan}
          name={fieldname}
          inputType={inputType}
          onChange={handleChange}
          errorMessages={errorMessages}
          messages={localeMessages}
          required
          formState={formState}
          selectOptions={selectOptions}
          disabled={disabled}
          maxLength={maxLength}
          showKredittvurderingInfo={formState.debtorType}
          kredittvurderingFieldsTitle={formState.debtorType === 'Næring' ? næringTitle : privatTitle}
          kredittvurderingFieldsText={formState.debtorType === 'Næring' ? næringFields : privatFields}
        />
      )
    }

const næringFields = 
`Generell informasjon
Pant
Tvangsforretning
Arrest
Aksjer og Aksjonærer
Betalingsanmerkninger
Regnskapstall
Roller
Eiendeler`;

const næringTitle = "Kredittvurdering av Næring viser:";

const privatFields = 
`Generell informasjon
Betalingsanmerkninger
Roller
Eiendeler
Pant
Ligninger
Tvangsforretning, Arrest
Gjeldsordning
Intet til utlegg
Aksjer`;

const privatTitle = "Kredittvurdering av Privat viser:";

    const debtorTypeOptions = [
      { value: "Privat", label: "Privat" },
      { value: "Næring", label: "Næring" }
    ];

    const getMethodToUse = (debtorIdentificationNumber) => {
        if ((formState.birthNumber && formState.birthNumber !== undefined) || (formState.orgNumber && formState.orgNumber !== undefined)) {

            if (formState.debtorType === 'Næring' && formState.orgNumber && formState.orgNumber.replace(/\s/g, "").length === 9 && formState.orgNumber.replace(/\s/g, "") !== '') {
                formState.birthNumber = undefined; // Fjerner motsatt nummer om begge har verdi
                return 'getCompanyRating';
            }
            if (formState.debtorType === 'Privat' && formState.birthNumber && formState.birthNumber.replace(/\s/g, "").length === 11 && formState.birthNumber.replace(/\s/g, "") !== '') {
                formState.orgNumber = undefined; // Fjerner motsatt nummer om begge har verdi
                return 'getPersonRating';
            }
        } else if (debtorIdentificationNumber !== undefined) {
            if (debtorIdentificationNumber.length === 9 && debtorIdentificationNumber && debtorIdentificationNumber.trim() !== '') {
                return 'getCompanyRating';
            }
            if (debtorIdentificationNumber.length === 11 && debtorIdentificationNumber && debtorIdentificationNumber.trim() !== '') {
                return 'getPersonRating';
            }
        } else {     
            return null;
        }
        return null;
    };


    const canDoCreditCheck = () => {
        return getMethodToUse() !== null;
    };

    const handleExport = async (data, debtorType, localeMessages) => {
        if (data === null || data === undefined) return;
        const user = auth.user;
        // Setter dagens dato
        const date = new Date();
        // Finner riktig kreditor her, det er en bug hvor kreditornavn ikke er satt om bruker har kun en kreditor i listen og ikke aktivt har trykket på den selv. 
        let currentKreditor = headerState.kreditorliste.find(e => e.customerNo === headerState.kreditorId)
        if (debtorType === 'Privat') {
          return await privatPdfV4(data, user.email, date, currentKreditor.disp, data.birthNo, localeMessages);
        } else if (debtorType === 'Næring') {
          return await næringPdfV4(data, user.email, date, currentKreditor.disp, data.orgNo, localeMessages);
        }
    };

    const showConfirmAction = () => {
        const number =
            (formState.birthNumber ?? "").replace(/\s/g, "") || 
            (formState.orgNumber ?? "").replace(/\s/g, "");
        setSelectedNumber(number);
        setShowConfirmActionModal(true);
    };

    const handleCloseConfirmActionModal = () => {
        setShowConfirmActionModal(false);
    };

    // const [shouldScrollOnResult, setShouldScrollOnResult] = useState(false);

    const handleOkConfirmActionModal = () => {
        setShowConfirmActionModal(false);
        // setShouldScrollOnResult(true);
        let type = formState.debtorType;
        let number = type === "Næring" ? formState.orgNumber : formState.birthNumber;
        props.getChosenRating(type, number.replace(/\s/g, ""), null);
    };

    // useEffect(() => {
    //   if (!shouldScrollOnResult) return;
    //   if (!companyRatingData && !personRatingData) return;
    //   setShouldScrollOnResult(false);
    //   document.activeElement?.blur();
    //   scrollDownALittle(500);
    // }, [shouldScrollOnResult, companyRatingData, personRatingData]);

    // const scrollDownALittle = (px = 120) => {
    //   const el = document.scrollingElement || document.documentElement;
    //   const max = el.scrollHeight - el.clientHeight;
    //   const target = Math.min(max, el.scrollTop + px);
    //   el.scrollTo({ top: target, behavior: 'smooth' });
    // };

    // Bruker for at Enter-tasten ikke skal reloade siden
    const onEnter = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (canDoCreditCheck()) showConfirmAction();
      }
    };


    function sumBelop(items) {
      if (!Array.isArray(items)) return '0';

      const total = items.reduce((sum, obj) => {
        const raw = obj?.monthlyAmount;
        let num;
        if (typeof raw === 'number') {
          num = raw;
        } else if (typeof raw === 'string') {
          const normalized = raw
            .trim()
            .replace(/\s+/g, '')
            .replace(/\./g, '')
            .replace(',', '.');
          num = parseFloat(normalized);
        } else {
          num = 0;
        }
        return sum + (isNaN(num) ? 0 : num);
      }, 0);

      return total
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    
    function generateTableLigninger(dataObject, config) {
      let items = dataObject
      if (!items) {
        items = []
      } else if (!Array.isArray(items)) {
        items = [items]
      }
    
      // Bruker Ligningsår som header
      const firstFieldTitle = config.fields[0]?.title || ''
      const subheaderLabels = items.map(item => item[config.subheaderKey])

      const headerRow = [firstFieldTitle, ...subheaderLabels]

      // Lager body og skipper ligningsår siden det er headeren
      const bodyFields = config.fields.slice(1)
      const body = bodyFields.map(field => {
        const row = [field.title]
        items.forEach(item => {
          const value = item[field.key]
          row.push(value != null ? String(value) : '')
        })
        return row
      })
    
    
      return { head: [headerRow], body }
    }

    // Tittel øverst, label til venstre og verdi til høyre. Kredittvurderingboksen har en bokstav-score helt til høyre
    // bruker addGapAfter for å lage whitespace mellom radene hvor nødvendig. 
    function KeyValueSection({ title = 'Kredittvurdering', items = [], score = '', reduceWidth = false }) {
      const scaleKey = formState.debtorType === 'Næring' ? 'company' : 'person';

      return (
        <SectionContainer reduceWidth={reduceWidth}>
          <TitleSection>
            {title}
            {score && (
              <ExtraValue style={{ color: getScoreColor(score, scaleKey) }}>
                {score}
                <RatingToolTip
                  title="Hvordan tolke ratingen?"
                  type={formState.debtorType}
                >
                  <i
                    className="fa fa-info-circle"
                    style={{ color: '#044F67', marginLeft: 8 }}
                  />
                </RatingToolTip>
              </ExtraValue>
            )}
          </TitleSection>
          <SectionTable>
            <TableBody>
              {items.map((item, idx) => (
                <TableRow key={idx} addGapAfter={item.addGapAfter}>
                  <LabelCell>{item.label}</LabelCell>
                  <ValueCell>{item.value}</ValueCell>
                </TableRow>
              ))}
            </TableBody>
          </SectionTable>
        </SectionContainer>
      )
    }

    function KeyValueSectionTwo({ title = 'Kredittvurdering', items = [], score = '', reduceWidth = false }) {
      return (
        <SectionContainerTwo reduceWidth={reduceWidth}>
          <TitleSection>
            {title}
            {score && <ExtraValue>{score}</ExtraValue>}
          </TitleSection>
          <SectionTable>
            <TableBody>
              {items.map((item, idx) => (
                <TableRow key={idx} addGapAfter={item.addGapAfter}>
                  <LabelCell>{item.label}</LabelCell>
                  <ValueCell>{item.value}</ValueCell>
                </TableRow>
              ))}
            </TableBody>
          </SectionTable>
        </SectionContainerTwo>
      )
    }

    function KeyValueSectionThree({ title = 'Pant', items = [] }) {
      return (
        <SectionContainerThree>
          <TitleSection>
            {title}
          </TitleSection>
          <SectionTable>
            <TableBody>
              {items.map((item, idx) => (
                <TableRow key={idx} addGapAfter={item.addGapAfter}>
                  <LabelCell>{item.label}</LabelCell>
                  <ValueCell>{item.value}</ValueCell>
                </TableRow>
              ))}
            </TableBody>
          </SectionTable>
        </SectionContainerThree>
      )
    }

    function GroupedKeyValueSection({
      title = 'Eiendeler',
      groups = [],
      reduceWidth = false
    }) {
      return (
        <SectionContainer reduceWidth={reduceWidth}>
          <TitleSection>
            {title}
          </TitleSection>
          <SectionTable>
            <TableBody>
              {groups.map((group, gi) => {
                const total = group.items.reduce((sum, it) => {
                  const num = parseFloat(it.value) || 0
                  return sum + num
                }, 0)
                return (
                  <React.Fragment key={gi}>
                    <GroupSubtitleRow>
                      <GroupSubtitleCell colSpan={2}>
                        {group.subtitle}
                      </GroupSubtitleCell>
                    </GroupSubtitleRow>
                    {group.items.map((item, idx) => (
                      <TableRow key={idx} addGapAfter={item.addGapAfter}>
                        <LabelCell>{item.label}</LabelCell>
                        <ValueCell>{item.value}</ValueCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TotalLabelCell>Totalt</TotalLabelCell>
                      <TotalValueCell>{total}</TotalValueCell>
                    </TableRow>
                  </React.Fragment>
                )
              })}
            </TableBody>
          </SectionTable>
        </SectionContainer>
      )
    }

    const toInt = (v) => {
      if (v == null) return NaN;
      if (typeof v === 'number') return Math.trunc(v);
      const s = String(v).replace(/[^\d-]/g, '');
      const n = Number(s);
      return Number.isFinite(n) ? n : NaN;
    };

    const parsePercent = (v) => {
      if (v == null) return NaN;
      if (typeof v === 'number') return v;
      const m = String(v).match(/-?\d+[.,]?\d*/);
      if (!m) return NaN;
      return Number(m[0].replace(',', '.'));
    };

    const percentFor = (item) => {
      const p = parsePercent(item.shareOfOwnership);
      if (Number.isFinite(p)) return p;

      const owned = toInt(item.numberOfOwnedShares);
      const total = toInt(item.totalNumberOfCompanyShares);
      if (Number.isFinite(owned) && Number.isFinite(total) && total > 0) {
        return (owned / total) * 100;
      }
      return NaN;
    };

    const classifyPercent = (pct, anchors = [100, 75, 50, 25], eps = 0.5) => {
      if (!Number.isFinite(pct)) return 'Mindre enn 25%';
      let nearest = anchors[0];
      for (const a of anchors) {
        if (Math.abs(pct - a) < Math.abs(pct - nearest)) nearest = a;
      }
      return Math.abs(pct - nearest) <= eps ? `${nearest}%` : 'Mindre enn 25%';
    };

    function buildCompanyItems(companies, anchors = [100, 75, 50, 25], eps = 0.5) {
      const counts = Object.fromEntries([
        ...anchors.map(a => [`${a}%`, 0]),
        ['Mindre enn 25%', 0],
      ]);

      for (const c of companies) {
        const pct = percentFor(c);
        const bucket = classifyPercent(pct, anchors, eps);
        counts[bucket] += 1;
      }

      return Object.entries(counts).map(([label, value]) => ({ label, value }));
    }

    function EiendelerPropertiesAndVehicles({ properties, vehicles, summary, shares, isPersonSearch, reduceWidth, localeMessages }) {

      const propertyCounts = properties.reduce((acc, p) => {
        const key = p.info.propertyType || 'Ukjent';
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});
      const propertyItems = Object.entries(propertyCounts).map(([label, count]) => ({
        label,
        value: String(count),
      }));

      const vehicleCounts = vehicles.reduce((acc, v) => {
        const key = v.info.vehicleType || 'Ukjent';
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});
      const vehicleItems = Object.entries(vehicleCounts).map(([label, count]) => ({
        label,
        value: String(count),
      }));

      let positionsItems = [];
      let companyItemsPerson = [];
      let companyItemsCompany = [];


      if (isPersonSearch) {
        // propertyItems.push({
        //   label: 'Eier bolig',
        //   value: summary.ownsHome,
        // });

        // vehicleItems.push({
        //   label: 'Eier kjøretøy',
        //   value: summary.ownsVehicle,
        // });

        positionsItems = [
          {
            label: 'Daglig leder',
            value: summary.numberOfCEOroles,
          },
          {
            label: 'Styreleder',
            value: summary.numberOfChairmanRoles,
          },
          {
            label: 'Styremedlem',
            value: summary.numberOfBoardMemberRoles,
          },
        ];
        companyItemsPerson = [
          {
            label: 'Enkeltpersonforetak',
            value: summary.soleProprietor,
          },
          {
            label: 'Majoritetseier selskap',
            value: summary.majorityOwnerCorporation,
          }
        ];
      }

      if (!isPersonSearch) {
        companyItemsCompany = buildCompanyItems(shares);
      }

      const groups = [
        {
          subtitle: 'Eiendom',
          items: propertyItems,
        },
        {
          subtitle: 'Kjøretøy',
          items: vehicleItems,
        },
        ...(isPersonSearch
        ? [
            {
              subtitle: 'Stillinger',
              items: positionsItems,
            },
            {
              subtitle: 'Selskaper',
              items: companyItemsPerson,
              omitTotal: true,
            },
          ]
        : []),
        ...(!isPersonSearch
          ? [
              {
                subtitle: 'Selskaper',
                items: companyItemsCompany,
              },
            ]
        : []),
      ];

      return (
        <GroupedKeyValueSectionTwo
          title="Eiendeler"
          groups={groups}
          reduceWidth={reduceWidth}
        />
      );
    }

    function GroupedKeyValueSectionTwo({
      title = 'Eiendeler',
      groups = [],
      reduceWidth = false,
    }) {
      return (
        <SectionContainerTwo reduceWidth={reduceWidth}>
          <TitleSection>
            {title}
          </TitleSection>
          <SectionTable>
            <TableBody>
              {groups.map((group, gi) => {
                const total = group.items.reduce((sum, it) => {
                  const num = parseFloat(it.value) || 0
                  return sum + num
                }, 0)
                return (
                  <React.Fragment key={gi}>
                    <GroupSubtitleRow>
                      <GroupSubtitleCell colSpan={2}>
                        {group.subtitle}
                      </GroupSubtitleCell>
                    </GroupSubtitleRow>
                    {group.items.map((item, idx) => (
                      <TableRow key={idx} addGapAfter={item.addGapAfter}>
                        <LabelCell>{item.label}</LabelCell>
                        <ValueCell>{item.value}</ValueCell>
                      </TableRow>
                    ))}
                    {!group.omitTotal && (
                      <TableRow>
                        <TotalLabelCell>Totalt</TotalLabelCell>
                        <TotalValueCell>{total}</TotalValueCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                )
              })}
            </TableBody>
          </SectionTable>
        </SectionContainerTwo>
      )
    }

    function GroupedKeyValueSectionWithSubsection({
      title = 'Roller',
      dataObject,
      config,
      reduceWidth = false
    }) {
      let items = dataObject.roles;
      if (!Array.isArray(items)) {
        items = items != null ? [items] : [];
      }

      if (items.length === 0) {
        return (
          <SectionContainer reduceWidth={reduceWidth}>
            <TitleSection>{title}</TitleSection>
            <SectionTable>
              <TableBody>
                <TableRow>
                  <LabelCell colSpan={2}>Ingen roller oppgitt</LabelCell>
                </TableRow>
              </TableBody>
            </SectionTable>
          </SectionContainer>
        );
      }
    
      const subKey = config.subheaderKey || 'description';
    
      // grupperer basert på rolleType
      const groups = Array.from(
        new Set(items.map(item => item[subKey] || ''))
      ).map(sub => ({
        subtitle: sub,
        items: items
          .filter(item => (item[subKey] || '') === sub)
          .map(item => ({ label: item.name + ' (f. ' + item.birthYear + ')' })),
      }));

      return (
        <SectionContainer reduceWidth={reduceWidth}>
          <TitleSection>{title}</TitleSection>
          <SectionTable>
            <TableBody>
              {groups.map((group, gi) => (
                <React.Fragment key={gi}>
                  <GroupSubtitleRow>
                    <GroupSubtitleCell colSpan={2}>
                      {group.subtitle}
                    </GroupSubtitleCell>
                  </GroupSubtitleRow>
                  {group.items.map((item, idx) => (
                    <TableRow key={idx}>
                      <LabelCell>{item.label}</LabelCell>
                      <ValueCell />
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
            </TableBody>
          </SectionTable>
          {/* <div style={{ margin: '12px', border: '1px solid #ddd' }}></div>
          <TitleSection>
            Signatur
          </TitleSection>
          <LabelCell></LabelCell> */}
        </SectionContainer>
      )
    }
    
    
    
    function LigningerTable({ title = 'Ligningstall', dataObject, config }) {
      const { head, body } = useMemo(
        () => generateTableLigninger(dataObject, config),
        [dataObject, config]
      )
      return (
          <StyledTable>
            <THead>
              <caption>{title}</caption>
              {head.map((row, i) => (
                <Row key={`head-${i}`}>  
                  {row.map((cell, j) => (
                    <Th key={`head-cell-${j}`}>{cell}</Th>
                  ))}
                </Row>
              ))}
            </THead>
            <TBody>
              {body.map((row, i) => (
                <Row key={`body-${i}`}>
                  {row.map((cell, j) => (
                    <Td key={`body-cell-${j}`}>{cell}</Td>
                  ))}
                </Row>
              ))}
            </TBody>
          </StyledTable>
      )
    }


    function generateTableRegnskap(dataObject, config) {
      let items = dataObject.financialStatements;
      if (!items) items = [];
      else if (!Array.isArray(items)) items = [items];

      // subheader labels (years)
      const subheaders = items.map(item => item[config.subheaderKey]);

      // split fields into groups
      const size1 = config.groupSizes[0] || 0;
      const size2 = config.groupSizes[1] || 0;
      const group1 = config.fields.slice(0, size1);
      const group2 = config.fields.slice(size1, size1 + size2);
      const group3 = config.fields.slice(size1 + size2);
      const groups = [group1, group2, group3];

      // build segments: for each group, one headerRow and corresponding bodyRows
      return groups.map((group, gi) => {
        const headerRow = [config.groupHeaders[gi] || ''].concat(subheaders);
        const bodyRows = group.map(field => {
          const row = [field.title];
          items.forEach(item => {
            const val = item[field.key];
            row.push(val != null ? val : '');
          });
          return row;
        });
        return { headerRow, bodyRows };
      });
    }

    function RegnskapTable({ title = 'Regnskap', dataObject, config }) {
      const segments = useMemo(
        () => generateTableRegnskap(dataObject, config),
        [dataObject, config]
      );
    
    
      return (
        <StyledTable>
          <THead>
            <RegnskapTitle>
              {title}
            </RegnskapTitle>
          </THead>
          {segments.map((seg, gi) => (
            <React.Fragment key={gi}>
              <Row key={`${gi}-body-${gi}`}>
                {seg.headerRow.map((cell, ci) => (
                  <Th key={ci}>{cell}</Th>
                ))}
              </Row>
              <TBody>
                {seg.bodyRows.map((row, ri) => (
                  <Row key={`${gi}-body-${ri}`}>  
                    {row.map((cell, ci) => (
                      <Td key={`body-cell-${ci}`}>{cell}</Td>
                    ))}
                  </Row>
                ))}
              </TBody>
            </React.Fragment>
          ))}
        </StyledTable>
      );
    }

    const handlePreview = async (ratingData) => {
      if (!ratingData) return;
      try {
        const blob = await handleExport(ratingData, ratingData.debtorType, localeMessages);

        if (!(blob instanceof Blob)) {
          console.error('Expected a Blob but got: ', blob)
          return
        }
        const url = URL.createObjectURL(blob)
        setPdfUrl(url)
        setModalOpen(true)
      } catch (err) {
        console.error('PDF preview failed', err)
      } finally {
      }
    }

    const hasData = d => d != null && (Array.isArray(d) ? d.length > 0 : true)

    const NæringRatingDataComponent = ({ kredittvurderingState, localeMessages, ratingData }) => {
      const organisationInformation = ratingData.organisationInformation || {};
      const risk = ratingData.risk || {};
      const legalRecords = ratingData.legalRecords || {};
      const shares = ratingData.shares || {};
      const shareholders = ratingData.shareholders || {};
      const roles = ratingData.roles || {};
      const properties = ratingData.properties || {};
      const vehicles = ratingData.vehicles || {};
      return (
        <>
          <div style={{ display: 'flex', gap: '16px', padding: '20px 0 12px 0' }}>
            <h2 style={{ margin: '0' }}>{ratingData.organisationInformation.organisationName}</h2>
            <ButtonContainer>
              <BfButtonBlue
                variant="primary"
                type="button"
                onClick={() => handlePreview(ratingData)}
              >
                {localeMessages.download}
              </BfButtonBlue>
            </ButtonContainer>
          </div>
    
          <FlexContainer>
            <KeyValueSection
              title="Kredittvurdering"
              score={risk.scoreRating}
              items={[
                { label: 'Kredittvurdering karakter', value: risk.scoreRating },
                { label: 'Kredittvurdering score', value: risk.normalisedScore + '/100' },
                { label: 'Kredittvurdering forklaring', value: risk.scoreRatingExplanation },
                { label: 'Råscore', value: ratingData.risk.rawScore + '/2000' },
                { label: 'Sannsynlighet for mislighold', value: risk.probabilityOfDefault },
                { label: 'Forslag til kredittgrensen(NOK)', value: risk.creditLimit },
                { label: 'Kreditt sperret', value: organisationInformation.creditFreeze, addGapAfter: true },
                { label: 'Status', value: organisationInformation.status },
                { label: 'Betalingsanmerkninger antall', value: risk.summary.paymentRemarksCount},
                { label: 'Betalingsanmerkninger beløp', value: risk.summary.paymentRemarksAmount, addGapAfter: true },
                { label: 'Intet til utlegg antall', value: risk.summary.noAssetsForSeizureCount },
              ]}
            />
            <KeyValueSection
              title="Grunndata"
              items={[
                { label: 'Organisasjonsnummer', value: formState.orgNumber },
                { label: 'Stiftelsesdato', value: organisationInformation.establishmentDate },
                { label: 'Antall ansatte', value: organisationInformation.numberOfEmployees },
                { label: 'Organisasjonsform', value: organisationInformation.organisationForm },
                { label: 'Næringskode', value: organisationInformation.industries[0].naceCode + ' ' + organisationInformation.industries[0].description, addGapAfter: true },
                // { label: 'Mvaregistrert', value: 'ja', addGapAfter: true },
                { label: 'Adresse', value: organisationInformation.businessAddress.street + ', ' + organisationInformation.businessAddress.municipalityNumber + ' ' + organisationInformation.businessAddress.municipalityName },
                // { label: 'Telefon', value: '51786850' },
              ]}
            />
            <GroupedKeyValueSectionWithSubsection
              title="Roller"
              dataObject={ratingData}
              config={næringConfigV4.roles}
              reduceWidth={true}
            />
          </FlexContainer>
          <FlexContainer>
            <RegnskapTable
              title="Utvalgte regnskapstall"
              dataObject={ratingData} 
              config={næringConfigV4.financialStatements} 
            />
            <RightColumn>
              <EiendelerPropertiesAndVehicles properties={properties} vehicles={vehicles} summary={risk.summary} shares={shares} isPersonSearch={false}/>
              <KeyValueSectionThree
                title="Pant"
                reduceWidth={false}
                items={[
                  { label: 'Utleggspant antall', value: risk.summary.assetSeizureCount },
                  { label: 'Utleggspant beløp', value: risk.summary.assetSeizureAmount, addGapAfter: true },
                  { label: 'Tvangsforretninger antall', value: risk.summary.propertyForeclosureCount },
                  { label: 'Tvangsforretninger beløp', value: risk.summary.propertyForeclosureAmount, addGapAfter: true },
                  { label: 'Arrest antall', value: risk.summary.arrestCount },
                  { label: 'Arrest beløp', value: risk.summary.arrestAmount, addGapAfter: true },
                  // { label: 'Pant fordringer antall', value: '0' },
                  // { label: 'Pant fordringer beløp', value: '0', addGapAfter: true },
                  // { label: 'Pant maskiner motorvogn antall', value: '0' },
                  // { label: 'Pant maskiner motorvogn beløp', value: '0', addGapAfter: true },
                  // { label: 'Pant redskap fiskeri antall', value: '0' },
                  // { label: 'Pant redskap fiskeri beløp', value: '0', addGapAfter: true },
                  // { label: 'Pant redskap landbruk antall', value: '0' },
                  // { label: 'Pant redskap landbruk beløp', value: '0'},
                ]}
              />
            </RightColumn>
          </FlexContainer>
            {hasData(legalRecords.paymentRemarks) ? (
              <AnmerkningerTable
                kredittvurderingState={kredittvurderingState} 
                localeMessages={localeMessages}
                fetchedRating={legalRecords.paymentRemarks}
              />) : null}
          {hasData(legalRecords.movableAssets) ? (
            <PantTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.movableAssets}
            />) : null}
          {hasData(legalRecords.propertyForeclosures) ? (
            <TvangEiendomTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.propertyForeclosures}
            />) : null}
          {hasData(legalRecords.propertyEnforcedActionRemarks) ? (
            <MerknaderEiendomTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.propertyEnforcedActionRemarks}
            />) : null}
          {hasData(shares) ? (
            <AksjerTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={shares}
            />) : null}
          {hasData(shareholders) ? (
            <AksjonaererTable
                kredittvurderingState={kredittvurderingState} 
                localeMessages={localeMessages}
                fetchedRating={shareholders}
            />) : null}
          {hasData(properties) ? (
            <EiendomTable 
                kredittvurderingState={kredittvurderingState} 
                localeMessages={localeMessages}
                fetchedRating={properties}
            />) : null}
          {hasData(vehicles) ? (
            <KjoeretoeyTable
                kredittvurderingState={kredittvurderingState} 
                localeMessages={localeMessages}
                fetchedRating={vehicles}
            />) : null}
        </>
      )
    };

    const PrivatRatingDataComponent = ({ kredittvurderingState, localeMessages, ratingData }) => {
      const personInformation = ratingData.personInformation || {};
      const risk = ratingData.risk || {};
      const legalRecords = ratingData.legalRecords || {};
      const shares = ratingData.shares || {};
      const incomeStatements = ratingData.incomeStatements || {};
      const roles = ratingData.roles || {};
      const properties = ratingData.properties || {};
      const vehicles = ratingData.vehicles || {};
      return (
        <>
          <div style={{ display: 'flex', gap: '16px', padding: '20px 0 12px 0' }}>
            <h2 style={{ margin: '0' }}>{personInformation.name}</h2>
            <ButtonContainer>
              <BfButtonBlue 
                variant="primary" 
                type="button" 
                onClick={() => handlePreview(ratingData)}
              >
                {localeMessages.download}
              </BfButtonBlue>
            </ButtonContainer>
          </div>
          <FlexContainer>
            <KeyValueSection
              title="Kredittvurdering"
              score={risk.scoreRating}
              items={[
                { label: 'Kredittvurdering karakter', value: risk.scoreRating },
                { label: 'Kredittvurdering score', value: risk.normalisedScore + '/100' },
                { label: 'Kredittvurdering forklaring', value: risk.scoreRatingExplanation },
                { label: 'Råscore', value: risk.rawScore + '/850' },
                { label: 'Sannsynlighet for mislighold', value: risk.probabilityOfDefault },
                { label: 'Forslag til kredittgrensen(NOK)', value: risk.creditLimit, addGapAfter: true },
                { label: 'Kreditt sperret', value: personInformation.creditFreeze, addGapAfter: true },
                { label: 'Betalingsanmerkninger antall', value: risk.summary.paymentRemarksCount },
                { label: 'Betalingsanmerkninger beløp', value: risk.summary.paymentRemarksAmount, addGapAfter: true },
                { label: 'Gjeldsordning åpning antall', value: risk.summary.debtRestructuringOpenedCount },
                { label: 'Gjeldsordning frivillig antall', value: risk.summary.debtRestructuringVoluntaryCount },
                { label: 'Gjeldsordning tvungen antall', value: risk.summary.debtRestructuringForcedCount, addGapAfter: true },
                { label: 'Intet til utlegg antall', value: risk.summary.noAssetsForSeizureCount, addGapAfter: true },
                { label: 'Utleggstrekk antall', value: legalRecords.salaryDeductions.length },
                { label: 'Utleggstrekk beløp', value: sumBelop(legalRecords.salaryDeductions) },
              ]}
            />
            <KeyValueSection
              title="Grunndata"
              items={[
                { label: 'Fødselsdato', value: personInformation.birthDate },
                { label: 'Fornavn', value: personInformation.firstName },
                { label: 'Etternavn', value: personInformation.lastName, addGapAfter: true },
                { label: 'Status', value: personInformation.status },
                { label: 'Under vergemål', value: personInformation.underGuardianship, addGapAfter: true },
                { label: 'Adresse', value: personInformation.residentialAddress.street + ', ' + personInformation.residentialAddress.municipalityNumber + ' ' + personInformation.residentialAddress.municipalityName },
              ]}
            />
            <EiendelerPropertiesAndVehicles properties={properties} vehicles={vehicles} summary={risk.summary} shares={shares} isPersonSearch={true}/>
          </FlexContainer>

          <FlexContainer>
            <LigningerTable dataObject={incomeStatements} config={privatConfigV4.incomeStatements} />
            <KeyValueSection
              title="Pant"
              reduceWidth='true'
              items={[
                { label: 'Utleggspant antall', value: risk.summary.assetSeizureCount },
                { label: 'Utleggspant beløp', value: risk.summary.assetSeizureAmount, addGapAfter: true },
                { label: 'Tvangsforretninger antall', value: risk.summary.propertyForeclosureCount },
                { label: 'Tvangsforretninger beløp', value: risk.summary.propertyForeclosureAmount, addGapAfter: true },
                { label: 'Arrest antall', value: risk.summary.arrestCount },
                { label: 'Arrest beløp', value: risk.summary.arrestAmount, addGapAfter: true },
                // { label: 'Pant fordringer antall', value: '0' },
                // { label: 'Pant fordringer beløp', value: '0', addGapAfter: true },
                // { label: 'Pant maskiner motorvogn antall', value: '0' },
                // { label: 'Pant maskiner motorvogn beløp', value: '0', addGapAfter: true },
                // { label: 'Pant redskap fiskeri antall', value: '0' },
                // { label: 'Pant redskap fiskeri beløp', value: '0', addGapAfter: true },
                // { label: 'Pant redskap landbruk antall', value: '0' },
                // { label: 'Pant redskap landbruk beløp', value: '0'},
              ]}
            />
          </FlexContainer>
          {hasData(legalRecords.paymentRemarks) ? (
            <AnmerkningerTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.paymentRemarks}
            />) : null }
          {hasData(roles) ? (
            <RollerTable 
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={roles}
            />) : null }
          {hasData(legalRecords.movableAssets) ? (
            <PantTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.movableAssets}
            />) : null }
          {hasData(legalRecords.propertyForeclosures) ? (
            <TvangEiendomTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.propertyForeclosures}
            />) : null }
          {hasData(legalRecords.propertyEnforcedActionRemarks) ? (
            <MerknaderEiendomTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.propertyEnforcedActionRemarks}
            />) : null }
          {hasData(properties) ? (
            <EiendomTable 
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={properties}
            />) : null }
          {hasData(vehicles) ? (
            <KjoeretoeyTable
                kredittvurderingState={kredittvurderingState} 
                localeMessages={localeMessages}
                fetchedRating={vehicles}
            />) : null}
          {hasData(shares) ? (
            <AksjerTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={shares}
            />) : null }
          {hasData(legalRecords.salaryDeductions) ? (
            <UtleggstrekkTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.salaryDeductions}
            />) : null }
           {hasData(legalRecords.noAssetsForSeizure) ? (
            <IntetTilUtleggTable
              kredittvurderingState={kredittvurderingState} 
              localeMessages={localeMessages}
              fetchedRating={legalRecords.noAssetsForSeizure}
            />) : null }
        </>
      )
    };

    return (
        <>
            <ConfirmActionModal
              show={showConfirmActionModal}
              okHandler={handleOkConfirmActionModal}
              cancelHandler={handleCloseConfirmActionModal}
              orgOrPersonNr={selectedNumber}
              messagePerson={localeMessages.confirm_action_person}
              messageOrg={localeMessages.confirm_action_org}
              checkboxText={localeMessages.checkbox_text}
              header={localeMessages.confirm_action_title}
              okCaption={localeMessages.confirm_action_ok}
              cancelCaption={localeMessages.confirm_action_cancel}
          />

          {modalOpen && pdfUrl && (
              <IframeModal
                src={pdfUrl}
                downloadName={`Kredittvurdering.pdf`}
                onClose={() => setModalOpen(false)}
              />
          )}

          <Container fluid="true">
            {(kredittvurderingState.fetchingRating) && <OverlaySpinner></OverlaySpinner>}

              <Form autoComplete="chrome-off">

                <KredittvurderingRowForm $bare>
                     <HeaderBar>
                        <TitleBlock>
                          <Heading>{localeMessages.checkTitle}</Heading>
                          <SubText>{localeMessages.checkParagraph1}</SubText>
                        </TitleBlock>
                        <TitleBlock>
                          <SubText style={{ fontSize: '16px' }}>Motorisert av</SubText>
                          <Logo src={LogoImage} alt="Bislab logo" />
                        </TitleBlock>
                      </HeaderBar>
                      <Divider />

                      <Controls>
                        <RadioRow>
                          {getFormField(1, 'debtorType', 'radioHorizontalLabel', debtorTypeOptions, props.disabled)}
                        </RadioRow>

                          <FieldRow onKeyDown={onEnter}>
                            <InputWrap>
                              {formState.debtorType === ''       && getFormField(1, '',  'cleaveOrgNrNoLabel', null, true)}
                              {formState.debtorType === 'Privat' && getFormField(1, 'birthNumber', 'cleaveFnrNrNoLabel', null, false)}
                              {formState.debtorType === 'Næring' && getFormField(1, 'orgNumber',   'cleaveOrgNrNoLabel', null, false)}
                            </InputWrap>

                            <CTAButton
                              type="button"
                              onClick={showConfirmAction}
                              disabled={!canDoCreditCheck()}
                            >
                              Søk
                            </CTAButton>
                          </FieldRow>
                      </Controls>

                      <BfRowFormTransition visible={showPrivatContent}>
                        {(showPrivatContent && formState.debtorType === 'Privat' && personRatingData !== undefined) && (
                          <>
                            <PrivatRatingDataComponent
                              kredittvurderingState={kredittvurderingState} 
                              localeMessages={localeMessages}
                              ratingData={personRatingData}
                            />
                          </>
                        )}
                      </BfRowFormTransition>
                      <BfRowFormTransition visible={showNæringContent}>
                        {(showNæringContent && formState.debtorType === 'Næring' && companyRatingData !== undefined) && (
                          <>
                            <NæringRatingDataComponent
                              kredittvurderingState={kredittvurderingState} 
                              localeMessages={localeMessages}
                              ratingData={companyRatingData}
                            />
                          </>
                        )}
                      </BfRowFormTransition>
                  </KredittvurderingRowForm>
              </Form>
          </Container>
        </>
    )
}

export default React.memo(KredittvurderingRatingForm)



